//https://react-leaflet.js.org/

import React from 'react'
import { Map, TileLayer, Polygon, Popup, Marker, Tooltip } from 'react-leaflet'
import { DeliveryMarker } from './deliveryMarker'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { firebasePointsToArray } from '../../utils'
import {
    Typography,
} from '@material-ui/core'

import { getColorByName } from '../../utils/colors'
import CustomMarker from './customMarker'
import moment from 'moment'
import 'moment/locale/es'
import useMainContext from '../../hooks/useMainContext'
import { normalizeOrderAddress } from '../../utils/address'
import OrderMapPopup from '../order/orderMapPopup'
moment.locale('es')
//import deliveryImg from '../../img/delivery.png'
/* import icon from 'leaflet/dist/images/marker-icon.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'
let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon */
L.Icon.Default.imagePath =
    '../node_modules/leaflet'

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});


//const url = 'http://{s}.tile.osm.org/{z}/{x}/{y}.png' //"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" //'https://stamen-tiles-{s}.a.ssl.fastly.net/toner/{z}/{x}/{y}{r}.png'


const styles = {
    wrapper: {
        height: '80vh',
        width: '100%',
        margin: '0 auto',
        display: 'flex'
    },
    map: {
        flex: 1
    }
}


const MapComponent = ({ mapZoom = null, deliveryPosition = null, centerMap = null, zones = [], markerPosition = null, showMarker = false, getPosition = () => { }, client = { name: 'Prueba' }, orders = [], clients = [], deliveryLocations = [] }) => {
    const { isAdmin, config = {}, businessInfo } = useMainContext()

    // console.log('MapComponent: ', config)
    const positionToObj = position => {
        let lat = config.mapCenter ? config.mapCenter[0] : (businessInfo?.position?.at(0))
        let lng = config.mapCenter ? config.mapCenter[1] : (businessInfo?.position?.at(1))

        if (Number(position?.length) > 0) {
            return { lat: position[0], lng: position[1] }
        }

        return { lat, lng }

    }


    const [currentPos, setCurrentPos] = React.useState(() => positionToObj(markerPosition))
    const [zoom, setZoom] = React.useState(mapZoom ? mapZoom : config.mapZoom ? config.mapZoom : 14)
    //console.log('markerPosition ', markerPosition)

    const handleClick = e => {
        //console.log('current position >> ' , e.latlng)
        setCurrentPos(e.latlng)
        getPosition(e.latlng)
    }

    const handleDragged = e => {
        //console.log('current position  >> ', e.target._latlng)
        setCurrentPos(e.target._latlng)
        getPosition(e.target._latlng)
    }

    const onViewportChanged = viewport => {
        //console.log('onViewportChanged',viewport)
        setZoom(viewport.zoom)
    }


    return (
        <div style={styles.wrapper}>
            <Map onViewportChanged={onViewportChanged} style={styles.map} onclick={handleClick} center={centerMap ? positionToObj(centerMap) : config.mapCenter ? config.mapCenter : [0, 0]} zoom={zoom}>
                <TileLayer url={config.mapURL ? config.mapURL : 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'} />
                {
                    zones.map(reg =>
                        <Polygon key={reg.id} positions={firebasePointsToArray(reg.positions)} name={reg.name} color={getColorByName(reg.color)} >
                            <Popup>
                                <p>{reg.name}</p>
                            </Popup>
                        </Polygon>
                    )
                }
                {
                    deliveryPosition && <DeliveryMarker position={positionToObj(deliveryPosition)} draggable={false}>
                        <Popup position={positionToObj(deliveryPosition)}>
                            {'Mi ubicacion'}
                        </Popup>
                    </DeliveryMarker>
                }
                {showMarker && markerPosition && <Marker ondragend={handleDragged} position={currentPos} draggable={true}>
                    <Popup position={currentPos}>
                        {`Dirección: ${normalizeOrderAddress(client.address)} ${client.number || ''}`}
                        {/* Current location: <pre>{JSON.stringify(currentPos, null, 2)}</pre> */}
                    </Popup>
                </Marker>
                }
                {
                    orders.map(o =>
                        <CustomMarker isAdmin={isAdmin} key={o.id} order={o} position={positionToObj(o.position)} draggable={false}>
                            <Tooltip permanent={true} sticky={false} opacity={0.8} direction={'bottom'}>
                                {o.cod}
                            </Tooltip>
                            <OrderMapPopup order={o} positionToObj={positionToObj} normalizeOrderAddress={normalizeOrderAddress} />
                        </CustomMarker>
                    )
                }
                {
                    deliveryLocations.filter(d => d.location).map(d =>
                        <DeliveryMarker key={d.id} position={positionToObj([d.location.latitude, d.location.longitude])} draggable={false}>
                            <Popup position={positionToObj([d.location.latitude, d.location.longitude])}>
                                <Typography>
                                    {d.name}
                                    <br />
                                    {moment(d.location.timestamp?.toDate()).format('HH:mm')}
                                </Typography>
                            </Popup>
                        </DeliveryMarker>
                    )
                }
                {
                    clients.filter(o => o.position).map(o =>
                        <Marker key={o.id} position={positionToObj(o.position)} draggable={false}>
                            <Popup position={positionToObj(o.position)}>
                                <Typography>
                                    {o.name}
                                    <br />
                                    {o.phone}
                                    <br />
                                    {normalizeOrderAddress(o.address)}
                                </Typography>
                            </Popup>
                        </Marker>
                    )
                }
            </Map>
        </div>
    )
}

MapComponent.defaultProps = {
    zoom: 14,
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
}

export default MapComponent